import { UpdateOrderRouteMutation } from "~/gql/mutations/orders.generated";
import { SetTenantDefaultRouteMutation } from "~/gql/mutations/route.generated";
import { GetRoutesQuery, GetTenantRouteConfigQuery } from "~/gql/queries/route.generated";

export const routeEndpoints = {
	GetRoutes: {
		providesTags: ["Routes"] as AddTagTypes,
		transformResponse: (res: GetRoutesQuery) => res
	},
	GetTenantRouteConfig: {
		providesTags: ["TenantRouteConfig"] as AddTagTypes,
		transformResponse: (res: GetTenantRouteConfigQuery) => res
	},
	SetTenantDefaultRoute: {
		invalidatesTags: ["TenantRouteConfig"] as AddTagTypes,
		transformResponse: (res: SetTenantDefaultRouteMutation) => res
	},
	UpdateOrderRoute: {
		invalidatesTags: ["Orders"] as AddTagTypes,
		transformResponse: (res: UpdateOrderRouteMutation) => res
	}
};
